import { render, staticRenderFns } from "./IconFavorite.vue?vue&type=template&id=2c809c95&"
import script from "./IconFavorite.vue?vue&type=script&lang=js&"
export * from "./IconFavorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports